export const COOKIE_LOST = 'COOKIE_LOST'

export const NETWORK_ERROR = 'NETWORK_ERROR'

export const SHOW_DIALOG = 'SHOW_DIALOG'

export const NETWORK_CODE = 'NETWORK_CODE'

